import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { BusinessHistoryComponent } from '../business-history/business-history.component';
import { BusinessHistoryCategory } from '../../common/enums/business-history-category.enum';
import { getEnterpriseLabels } from '../../common/utils/enterprise-labels.util';
import { SecurityDomain } from '../../common/enums/security-domain';
import { AuditReportRequestModalComponent } from '../audit-report-request-modal/audit-report-request-modal.component';

@Component({
    selector: 'lib-audit-report-header',
    imports: [
        NgIf,
        BusinessHistoryComponent,
        AuditReportRequestModalComponent
    ],
    templateUrl: './audit-report-header.component.html',
    styleUrl: './audit-report-header.component.scss'
})
export class AuditReportHeaderComponent implements OnInit {
    @Input() enterpriseId = 0;
    @Input() enterpriseLabels = getEnterpriseLabels(SecurityDomain.MODMED);
    @Output() reloadAuditReportData = new EventEmitter<boolean>();

    showAuditReportRequestModal = false;
    eventCategory: BusinessHistoryCategory = BusinessHistoryCategory.AUDIT_REPORTS;

    ngOnInit(): void {
        this.reloadData();
    }

    requestAuditReport(): void {
        this.showAuditReportRequestModal = true;
    }

    reloadData(): void {
        this.reloadAuditReportData.emit(true);
    }

    public handleAuditReportRequest(isRequesting: boolean): void {
        if (!isRequesting) {
            this.showAuditReportRequestModal = false;
            this.reloadData();
        }
    }
}
